import store from '../store/index'
const WEB_VERSION = "0.0.2";
const SIGN_VERSION = "1";
const WEB_NAME = "WordTrip";
const API_URL = "https://www.worldtrip.vip/api/v1";

var AppVar = {
    // 信息展示
    A_USER_INFO: API_URL + '/profile/fetch',
    A_USER_LOGIN: API_URL + '/account/login',
    A_SEND_CODE: API_URL + '/account/sendcode',
    A_USER_EDIT: API_URL + '/profile/editpersonaldata',
    A_CHANGE_PWD: API_URL + '/account/deal_password',
    A_USER_NOTICE: API_URL + '/account/msg_notice',


    A_HOME_HOTELS: API_URL + '/index/hotels',
    A_CITYS_SEARCH: API_URL + '/citys/search_new',
    A_INDEX_HOTEL: API_URL + '/index/index_hot_city',
    A_HOTEL_SEARCH: API_URL + '/hotel/search_new',
    A_HOME_ROOMS_N: API_URL + '/hotel/hotel_detail',
    A_HOME_FIND_N: API_URL + '/hotel/find_hotel_rooms',
    A_ROOMS_DETAIL_N: API_URL + '/hotel/rooms_detail',
    A_HOTEL_COLLECTION: API_URL + '/hotel/is_hotel_store',
    A_HOTEL_PRICE: API_URL + '/hotel/prices_new',



    // 订单相关
    A_SEND_EMAIL: API_URL + '/profile/sendordertouser',
    A_ORDER_CANCLE: API_URL + '/hotel/cancel_order',
    A_ORDER_LIST: API_URL + '/hotel/order_list',
    A_ORDER_PAY: API_URL + '/hotel/order_detail',
    A_CASH_APPLY: API_URL + '/account/apply_withdraw',
    A_CASH_LIST: API_URL + '/account/withdraw_list',
    A_INVOICE_APPLY: API_URL + '/account/apply_invoice',
    A_INVOICE_LIST: API_URL + '/account/invoice_list',
    A_CONFIRM_ORDER_N: API_URL + '/hotel/book_hotel_rooms',
    A_FOUR_MONTH: API_URL + '/account/get_four_month_cash',
    A_COLLECTE_HOTEL: API_URL + '/hotel/hotel_store',
    A_COLLECTE_LIST: API_URL + '/hotel/hotel_store_list',

    // 代理
    A_AGENT_LIST: API_URL + '/account/agent_list',
    A_AGENT_ADD: API_URL + '/account/add_agent_user',
    A_AGENT_PASS: API_URL + '/account/edit_agent_pass',
    A_AGENT_DETAIL: API_URL + '/account/agent_user_detail',
    A_AGENT_PERCENT: API_URL + '/account/edit_agent_percent',

    // VCC
    A_APPLY_CARD: API_URL + '/card/applycard',
    A_CARD_LIST: API_URL + '/card/card_list',
    A_CARD_DETAIL: API_URL + '/card/card_detail',
    A_GET_CNY_MONEY: API_URL + '/card/get_cny_money',
    A_GET_VCC_CONTENT: API_URL + '/card/get_vcc_email',

    USER_ID: '',
    USER_SIGN: '',
    GetAppHeaders: function () {
        return {
            "x-bonums-user-id": this.USER_ID,
            "x-bonums-user-sign": this.USER_SIGN,
            "x-bonums-sign-version": SIGN_VERSION,
            'content-Type': 'application/x-www-form-urlencoded'
        }
    }
}
function GetAppVar() {
    AppVar.USER_ID = "";
    if (!AppVar.USER_ID) {
        try {
            var userinfo = store.state.userInfo;
            if (userinfo['userid']) {
                AppVar.USER_ID = userinfo['userid'];
                AppVar.USER_SIGN = userinfo['sign'];
            }
        } catch (e) { }
    }
    return AppVar;
}
function checkEmail(email) {
    let str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
    if (str.test(email)) {
        return true
    } else {
        return false
    }
}
function getNowDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + '-' + month + '-' + strDate;
    return currentdate;
}
function formatDate(dateStr) {
    if (!dateStr) { return false };
    let dateArr = dateStr.split('-');
    let year = dateArr[0];
    let month = dateArr[1].substr(0, 1) == 0 ? dateArr[1].substr(1, 1) : dateArr[1];
    let day = dateArr[2].substr(0, 1) == 0 ? dateArr[2].substr(1, 1) : dateArr[2];
    return month + '月' + day + '日';
}
function initWeek(dateStr) {
    let idxArray = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return idxArray[new Date(dateStr).getDay()];
}
function dateDiff(sDate1, sDate2) {
    if (!sDate1 || !sDate2) { return false };
    var aDate, oDate1, oDate2, iDays;
    aDate = sDate1.split("-");
    oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);
    aDate = sDate2.split("-");
    oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
    return iDays;
}
function objToArr(obj) {
    var arr = [];
    for (let i in obj) {
        arr.push(obj[i]);
    }
    return arr;
}
function nl2br(str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br/>' : '<br>';
    return (str + '').replace(/([^>]?)(\n)/g, '$1' + breakTag + '$2');
}
export default {
    checkEmail,
    formatDate,
    dateDiff,
    initWeek,
    nl2br,
    objToArr,
    getNowDate,
    GetAppVar
}



// WEBPACK FOOTER //
// ./src/common/common.js